import { disabledFeatureHint } from './pues';
import { siblings } from '../../utilities/traversal';
import { getPrice } from './price';
import { getReminder, setReminder, removeReminder, setupTooltip } from "./reminder";
// import { addToBasket } from './tocart';

export class ListView {

  urlPrefix = '';

  init() {
    /**
     * List item feature click listener
     */

    const param = document.querySelector('[data-param-id="urlPrefix"]');
    this.urlPrefix = param ? param.textContent : '';

    document.querySelector('.product-list-wrapper').addEventListener('click', (e) => {
      const thisEl = (e.target as HTMLElement);
      const featureToggle = thisEl.closest('.js-feature-toggle-value') as HTMLElement;
      if (featureToggle) {
        const featureToggleWrapper = featureToggle.closest('.feature-toggle-wrapper') as HTMLElement;
        const productWrapper = featureToggle.closest('.js-pues-list-productId') as HTMLElement;
        const lastSelectedlabel = featureToggle.dataset.featureLabel;

        let selectedFeatures: any = {};
        let productId = '';

        if (productWrapper) {
          productId = productWrapper.dataset.productId;
        } else {
          productId = featureToggleWrapper.dataset.productId;
        }

        const featureHint = featureToggleWrapper.querySelector('.feature-toggle-disabled-hint');
        const featureError = featureToggleWrapper.querySelector('.feature-toggle-error');

        featureHint && featureHint.parentNode.removeChild(featureHint);
        featureError && featureError.parentNode.removeChild(featureError);

        const activeFilters = featureToggle.parentElement.querySelectorAll('.feature-toggle-active');
        activeFilters.forEach((filter: HTMLElement) => {
          filter.classList.remove('feature-toggle-active');
        });
        featureToggle.classList.add('feature-toggle-active');

        const featureSections = featureToggleWrapper.querySelectorAll('.js-feature-toggle');

        featureSections.forEach((section: HTMLElement, index) => {
          const label = section.getAttribute('data-feature-label');
          let hasActive = 0;

          section.querySelectorAll('.js-feature-toggle-value').forEach((feature: HTMLElement) => {
            if (feature.classList.contains('feature-toggle-active')) {
              hasActive = 1;
              selectedFeatures[label] = feature.dataset.value;
            }
          });

          // add empty value if there is no matching
          if (hasActive === 0) {
            selectedFeatures[label] = '';
          }
        });

        const requestJson = {
          'lastSelectedFeatureName': lastSelectedlabel,
          'selectedFeatureValues': selectedFeatures
        };

        window.fetch(this.urlPrefix + '/product/feature/dropdown/' + productId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
          body: JSON.stringify(requestJson),
        })
        .then(res => res.json())
        .then((response) => this.handleResponse(response, featureToggleWrapper, productWrapper, productId))
        .catch(err => {
          console.log(err);
        });
      }

      // const inc = thisEl.classList.contains('inc');
      // if (inc) {
      //   const quantityInput = thisEl.parentElement.querySelector('input');
      //   let newVal = parseInt(quantityInput.value);
      //   const max = quantityInput.getAttribute('max');

      //   if (thisEl.textContent === '+') {
      //       if (newVal < 1 || newVal === null || typeof newVal === 'undefined') {
      //           newVal = 0
      //       }
      //       newVal = newVal + 1;
      //   } else {
      //       if (newVal < 1 || newVal === null || typeof newVal === 'undefined') {
      //           newVal = 2
      //       }
      //       // Don't allow decrementing below 1
      //       if (newVal > 1) {
      //           newVal = newVal - 1;
      //       } else {
      //           newVal = 1;
      //       }
      //   }

      //   this.updateInc(quantityInput, newVal.toString(), max);
      // }

      // const basket = thisEl.classList.contains('add-to-basket');

      // if (basket) {
      //   const basketBtn = thisEl as HTMLButtonElement;
      //   addToBasket(basketBtn, true, false);
      // }
      const reminder = thisEl.classList.contains('add-to-reminder') || thisEl.parentElement.classList.contains('add-to-reminder');

      if (reminder) {
        let reminderBtn;
        if(thisEl.classList.contains('add-to-reminder')) {
          reminderBtn = thisEl as HTMLButtonElement;
        } else {
          reminderBtn = thisEl.parentElement as HTMLButtonElement;
        }
        const articleId = thisEl.closest('.pues-list-item').getAttribute('data-article-id');

        if (reminderBtn.classList.contains('setReminder')) {
          setReminder(reminderBtn, articleId, 'toast');
        }
        if (reminderBtn.classList.contains('removeReminder')) {
          removeReminder(reminderBtn, articleId, 'toast');
        }
      }
    });

    const reminderBtns = Array.from(document.querySelectorAll('.basket-reminder-wrapper:not(.hidden) .add-to-reminder'));
    reminderBtns.forEach(btn => {
      const aId = btn.closest('.pues-list-item').getAttribute('data-article-id');
      getReminder(btn as HTMLButtonElement, aId);
    })

    const listItems = document.querySelectorAll('.js-pues-list-productId');
    disabledFeatureHint(listItems);
  }

  // updateInc(input: HTMLInputElement, newVal: string, max?: string) {
  //   input.value = newVal;
  //   const quantity = parseInt(newVal);
  //   const dec = input.closest('.form-field-quantity').querySelector('.incrementer-dec');
  //   const inc = input.closest('.form-field-quantity').querySelector('.incrementer-inc');
  //   if (quantity <= 1) dec.classList.add('incrementer-inactive');
  //   if (quantity > 1) dec.classList.remove('incrementer-inactive');
  //   if (quantity >= parseInt(max)) inc.classList.add('incrementer-inactive');
  //   if (quantity < parseInt(max)) inc.classList.remove('incrementer-inactive');
  // }

  handleResponse(response: any, featureToggleWrapper: HTMLElement, productWrapper: HTMLElement, productId: string) {
    if(typeof response !== 'undefined') {
      for (let key in response) {
        const disabled = response[key].disabledValues;
        const hidden = response[key].hiddenValues;

        const variantDropDown = document.getElementById('variant-filter-' + response[key].id) as HTMLSelectElement;
        variantDropDown && (variantDropDown.value = response[key].selectedValue);

        const featureToggleLabel = featureToggleWrapper.querySelector('#feature-' + response[key].id + ' .feature-toggle-label');

        if (response[key].selectedValue == 'null') {
          let errorText = featureToggleWrapper.querySelectorAll('.feature-toggle-error-text')[0].textContent;
          let newcontent = document.createElement('span');
          newcontent.className = 'feature-toggle-error';
          newcontent.innerHTML = errorText;
          featureToggleLabel && featureToggleLabel.appendChild(newcontent);
        }

        // remove active value
        featureToggleLabel && (featureToggleLabel.querySelectorAll('span.feature-toggle-unit')[0].innerHTML = '');

        // set values
        const toggles = featureToggleWrapper.querySelectorAll('#feature-' + response[key].id + ' .js-feature-toggle-value');
        if(typeof toggles !== 'undefined') {
          toggles.forEach((toggle: HTMLElement) => {
            const value = toggle.getAttribute('data-value');
            const inArrayDisabled = disabled.indexOf(value);
            const inArrayHidden = hidden.indexOf(value);
            let unit = '';

            // set disabled values
            if (inArrayDisabled === -1) {
              toggle.classList.remove('feature-toggle-disabled');
            } else {
              toggle.classList.add('feature-toggle-disabled');
            }

            // set hidden values
            if (inArrayHidden === -1) {
              toggle.classList.remove('feature-toggle-hidden');
            } else {
              toggle.classList.add('feature-toggle-hidden');
            }

            // set active value
            if (value === response[key].selectedValue) {
              toggle.classList.add('feature-toggle-active');
              if (typeof response[key].unit !== 'undefined' && response[key].unit !== 'null' && response[key].unit !== null) {
                  unit = response[key].unit;
              }
              const toggleLabelSibling = siblings(toggle, '.feature-toggle-label')[0];
              toggleLabelSibling && (toggleLabelSibling.querySelectorAll('span')[0].innerHTML = value + ' ' + unit);
            } else {
              toggle.classList.remove('feature-toggle-active');
            }
          });
        }
      }
    }

    // get article from mapping
    let hash: any = [];
    let i = 0;

    featureToggleWrapper.querySelectorAll('.js-feature-toggle-value').forEach((element: HTMLElement) => {
      if (element.classList.contains('feature-toggle-active')) {
        let dataValue = element.dataset.value;
        dataValue = dataValue.replace(/'/g, '&#39;');
        hash[i] = dataValue; // .trim()
        i++;
      }
    });

    let featureHash = hash.join('|') + '|';
    let articleId = window['fullFeatureArticleMap'][productId][featureHash];

    if (typeof articleId === 'undefined' || articleId === '') {
      const reversed = hash.reverse();

      featureHash = reversed.join('|') + '|';
      articleId = window['fullFeatureArticleMap'][productId][featureHash];
    }

    if (articleId && productWrapper) {
      this.updateArticle(articleId, productId, productWrapper);
      productWrapper.dataset.articleId = articleId;
    }
  }

  updateArticle(articleId: string, productId: string, productWrapper: HTMLElement) {
    window.fetch(this.urlPrefix + '/product/article/' + articleId)
      .then(res => res.json())
      .then((data) => {
        const article = data[0];
        const viewParams = data[1];
        const warning = document.querySelector('.feature-warning') as HTMLElement;
        warning && (warning.style.display = 'none');
        this.refreshContent(article, productId, productWrapper);
    }).catch(err => {
      console.log(err);
    });
  }

  updateEnergyLabel(articleId: string, item: HTMLElement) {
    const energylabelWrapper: HTMLElement = item.querySelector('.energylabel');
     if (!energylabelWrapper) return;
     const energylabelOpen = item.querySelector('.energylabel .energylabel-open');
     const energylabelPdf: HTMLAnchorElement = item.querySelector('.energylabel .energylabel-pdf');
     const energylabelThumb: HTMLImageElement = item.querySelector('.energylabel .energylabel-open img');
     const energylabelVariants = item.querySelector('.energylabel-variants');

     if (energylabelVariants && energylabelVariants.getAttribute('data-thumbsrc-' + articleId)) {
       energylabelThumb.src = energylabelVariants.getAttribute('data-thumbsrc-' + articleId);
       energylabelWrapper.style.display = 'flex';

       if (energylabelOpen && energylabelVariants.getAttribute('data-imgsrc-' + articleId)) {
         energylabelOpen.setAttribute('data-imgsrc', energylabelVariants.getAttribute('data-imgsrc-' + articleId));
       }
       if (energylabelOpen && energylabelPdf && energylabelVariants.getAttribute('data-pdfsrc-' + articleId)) {
         energylabelOpen.setAttribute('data-pdfsrc', energylabelVariants.getAttribute('data-pdfsrc-' + articleId));
         energylabelPdf.href = energylabelVariants.getAttribute('data-pdfsrc-' + articleId);
         energylabelPdf.style.display = 'block';
       } else {
         energylabelPdf.style.display = 'none';
       }
     } else {
       energylabelWrapper.style.display = 'none';
     }
  }

  parseHTML(str: string) {
    const tmp = document.implementation.createHTMLDocument();
    tmp.body.innerHTML = str;
    return tmp.body.children;
  };

  refreshContent(article: any, productId: string, productWrapper: HTMLElement) {
    productWrapper.querySelector('.js-pues-article-title .js-pues-article-link').innerHTML = article.shortDescription;
    const articleLinks = productWrapper.querySelectorAll('.js-pues-article-link');
    articleLinks.forEach((item: HTMLAnchorElement) => item.href = article.mainUrl.originalUrl);

    getPrice(article.id, 1, '', 'v3', true, productId).then((articlePriceSnippet: any) => {
      if (articlePriceSnippet && articlePriceSnippet.toString().includes('<script')) {
        var Globaleval = (code: string) => {
          let script = document.createElement('script');
          script.text = code;

          document.head.appendChild(script).parentNode.removeChild(script);
        };

        const snippet = (this.parseHTML(articlePriceSnippet.toString()) as NodeList | any);

        snippet.forEach((el: Element) => {
          const script = el.querySelector('script');
          script && Globaleval(script.innerText);
        });
      }
      productWrapper.querySelector('.js-pues-list-product-price').innerHTML = articlePriceSnippet;
      // productWrapper.querySelector('.js-pues-article-desc').innerHTML = '';

      if (typeof article.stock !== 'undefined') {
        if (typeof article.stock.deliveyPeriodText !== 'undefined') {
          productWrapper.querySelector('.js-pues-article-delivery').innerHTML = article.stock.deliveyPeriodText;
        }
      }

      const deliveryTime = productWrapper.querySelector('.delivery-time') as HTMLElement;
      const alertMessage = productWrapper.querySelector('.not-available') as HTMLElement;
      const cartBtn = productWrapper.querySelector('.add-to-basket') as HTMLElement;
      const reminderWrapper = productWrapper.querySelector('.basket-reminder-wrapper') as HTMLElement;
      const reminderBtn = productWrapper.querySelector('.add-to-reminder') as HTMLButtonElement;

      cartBtn.dataset.articleId = article.id;

      const notAvailble = article.status.tmpNotAvailable;
      if (notAvailble) {
        if(reminderBtn) getReminder(reminderBtn, article.id);
        deliveryTime && (deliveryTime.style.display = 'none');
        alertMessage && (alertMessage.style.display = 'block');
        cartBtn.setAttribute('disabled', 'disabled');
        reminderWrapper && reminderWrapper.classList.remove('hidden');
        reminderBtn && reminderBtn.removeAttribute('disabled');
      } else {
        deliveryTime && (deliveryTime.style.display = 'inline');
        alertMessage && (alertMessage.style.display = 'none');
        cartBtn.removeAttribute('disabled');
        reminderWrapper && reminderWrapper.classList.add('hidden');
        reminderBtn && reminderBtn.setAttribute('disabled', 'disabled');
      }

      this.loadImage(article.id, productWrapper);
    });

    this.updateEnergyLabel(article.id, productWrapper);
  }

  loadImage(article: any, productWrapper: HTMLElement) {
    window.fetch(this.urlPrefix + '/product/article/' + article + '/asset/shop190_high')
      .then(res => res.json())
      .then((article) => {
        if (typeof article.imageUrl != 'undefined' && article.imageUrl != '') {
          ((productWrapper.querySelector('.js-pues-article-image img') as HTMLImageElement).src = article.imageUrl);
          productWrapper.querySelector('.js-pues-article-image source').setAttribute('srcset', article.imageUrl);
        }
    }).catch(err => {
      console.log(err);
    });
  }
}
